import { RenderHtml } from '../../../utils';
import * as React from 'react';
import { HeightAnimation, OpacityAnimation, KeyCode } from '@wix/answers-ui-libby';
export const CollapsibleToggleAnimation = (props) => (React.createElement(HeightAnimation, { show: props.show },
    React.createElement(OpacityAnimation, { show: props.show }, props.children)));
export class CollapsibleComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { isOpen: false };
        this.componentDidMount = () => {
            document.addEventListener('keydown', this.openOnKeyboardSearch);
            this.syncInert();
        };
        this.componentDidUpdate = () => this.syncInert();
        this.syncInert = () => { var _a; return (_a = this.contentRef) === null || _a === void 0 ? void 0 : _a.toggleAttribute('inert', !this.state.isOpen); };
        this.componentWillUnmount = () => {
            var _a, _b;
            (_a = this.collapsRef) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', this.onAccessibilityKeyup);
            (_b = this.collapsRef) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.onAccessibilityClick);
            document.removeEventListener('keydown', this.openOnKeyboardSearch);
        };
        this.openOnKeyboardSearch = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.keyCode === KeyCode.F) {
                this.setState({ isOpen: true });
            }
        };
        this.toggleCollapsible = () => this.setState((state) => ({ isOpen: !state.isOpen }));
        this.onAccessibilityKeyup = (e) => {
            if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                this.toggleCollapsible();
            }
        };
        this.onAccessibilityClick = () => { var _a, _b; return (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a); };
        this.setCollapsRef = (elem) => {
            if (elem) {
                this.collapsRef = elem;
                elem.addEventListener('keyup', this.onAccessibilityKeyup);
                elem.addEventListener('click', this.onAccessibilityClick);
            }
        };
    }
    render() {
        const props = this.props;
        const bodyClassName = `collapsible-body ${this.state.isOpen ? 'open' : ''}`;
        return (React.createElement("div", { className: 'component collapsible-component', "data-component-type": 'collapsible' },
            React.createElement("div", { className: bodyClassName },
                React.createElement("div", { tabIndex: 0, ref: this.setCollapsRef, className: 'collapsible-wrapper' },
                    React.createElement("div", { role: 'button', "aria-expanded": this.state.isOpen, className: 'collapsible-heading', onClick: this.toggleCollapsible },
                        React.createElement("div", { className: 'title' }, props.value.title)),
                    React.createElement("div", { ref: el => this.contentRef = el !== null && el !== void 0 ? el : undefined, "aria-hidden": !this.state.isOpen, className: 'collapsible-content' },
                        React.createElement(CollapsibleToggleAnimation, { show: this.state.isOpen },
                            React.createElement(RenderHtml, { html: props.value.html, className: 'rendered-html' })))))));
    }
}
